<script setup lang="ts">
const props = defineProps<{
  announcement: {
    key: string
    title: string
    message: string
  }
}>()

const emit = defineEmits<{
  dismiss: []
}>()

const { $api } = useNuxtApp()
const { user, loadUser } = useAuthStore()

const genderOptions = useEnumGenderGroup().gendersAsOptions()

const { submit, isSaving } = useFormHelper<'/name-confirmation/confirm', 'post'>({
  initialState: {
    first_name: user?.first_name || '',
    last_name: user?.last_name || '',
    nickname: user?.nickname || '',
    gender: user?.gender as 'male' | 'female' | 'other' || 'other',
  },
  path: undefined,
  saveEndpoint: '/name-confirmation/confirm',
  method: 'post',
  notifyMessage: 'Name confirmed successfully',
  afterSave: async () => {
    await loadUser(true)

    // Mark announcement as dismissed
    await $api('/feature-announcements/dismiss', {
      method: 'post',
      body: {
        announcement_key: props.announcement.key,
      },
    })

    emit('dismiss')
  },
})
</script>

<template>
  <UiDialog :open="true">
    <UiDialogContent
      :title="announcement.title"
      :description="announcement.message"
      class="max-w-md"
    >
      <UiFormSimple @submit="submit">
        <UiFullInput
          name="first_name"
          :label="$t('First name')"
          type="text"
          required
        />

        <UiFullInput
          name="last_name"
          :label="$t('Last name')"
          type="text"
          required
        />

        <UiFullInput
          name="nickname"
          :label="$t('Nickname')"
          type="text"
          required
        />

        <UiFullSelect
          name="gender"
          :label="$t('Gender')"
          required
        >
          <UiSelectItem
            v-for="option in genderOptions"
            :key="option.value"
            :value="option.value"
          >
            {{ option.label }}
          </UiSelectItem>
        </UiFullSelect>

        <UiAlert
          variant="warning"
          class="text-sm"
        >
          <strong>{{ $t('Important') }}:</strong> {{ $t('After confirming, you can only change your nickname. For first and last name and gender changes, contact support') }}
        </UiAlert>
        <UiDialogFooter>
          <UiButton
            type="submit"
            :text="$t('Confirm Name')"
            :loading="isSaving"
          />
        </UiDialogFooter>
      </UiFormSimple>
    </UiDialogContent>
  </UiDialog>
</template>
